import React, {useEffect, useState} from "react";

import {
    Button,
    CircularProgress, Space
} from "../../../../../common/components/libs";
import {observer} from "mobx-react";
import {useStores} from "../../../../../hooks";
import {
    localize,
    toLocalizedString,
} from "../../../../../common/libs";
import {SnackbarType} from "../../../../../stores/common";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    InputLabel,
    MenuItem,
    OutlinedInput,
    RadioGroup,
    FormControl,
    Select, useMediaQuery, useTheme, DialogActions, FormControlLabel, Radio
} from "@material-ui/core";
import {Trans, useTranslation} from "react-i18next";
import style from "../style.module.css";
import {BookingFormType} from "../../../store/booking/forms";


const CopyBookingItemForm = () => {
    const {bookingStore, generalStore, generalMenuStore} = useStores();
    const {open, current} = bookingStore.forms.forms[BookingFormType.copyBookingItem];
    const {t} = useTranslation(["general", "booking"]);
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.up('sm'));
    const category = bookingStore.getCategoryById(current?.data.menuBookingCategoryId);

    const [isCopyingItemInProgress, setIsCopyingItemInProgress] = useState(false);
    const [copyToThisMenu, setCopyToThisMenu] = useState(true);
    const [menuId, setMenuId] = useState<number | undefined>(undefined);
    const [categoryId, setCategoryId] = useState<number | undefined>(undefined);
    const [originalMenuId, setOriginalMenuId] = useState(bookingStore.currentMenu.id)

    useEffect(() => {
        if (!current) return;
        if (menuId) bookingStore.getCategoriesByMenuId(menuId);
        setMenuId(menuId);
        setCategoryId(categoryId);
    }, [current, menuId]);

    useEffect(() => {
        if(open){
            setOriginalMenuId(bookingStore.currentMenu.id);
        }
    }, [open])

    if (!bookingStore.currentMenu) return null;
    if (bookingStore.currentMenu.menuCategories.length === 0) return null;
    if (!current) return;

    const forms = bookingStore.forms;
    const closeForm = () => {
        setMenuId(undefined);
        forms.closeForm(BookingFormType.copyBookingItem);
    };

    const copy = async () => {
        setIsCopyingItemInProgress(true);
        let res;
        let newCategory;
        if (copyToThisMenu) {
            const newName = toLocalizedString(localize(current.data.name) + " (1)");
            res = await bookingStore.createMenuItem({...current.data, name: newName});
            newCategory = category.id;
        } else {
            bookingStore.setCurrentMenuId(menuId);
            await bookingStore.fetchMenuById(menuId);

            if (!categoryId) {
                await bookingStore.createCategory({
                    name: localize(category.data.name),
                    sortOrder: category.data.sortOrder,
                    isInStopList: category.data.isInStopList,
                });
                newCategory = bookingStore.newCategoryId;
            } else {
                newCategory = categoryId;
            }
            res = await bookingStore.createMenuItem({...current.data, menuBookingCategoryId: newCategory});
        }
        if (!res) {
            const params: ({ type: SnackbarType, title: string, description?: string }) = {
                title: t("general:somethingWentWrong"),
                type: SnackbarType.error,
                description: t("general:tryAgain")
            }
            generalStore.showSnackbar(params);
        } else {
            setIsCopyingItemInProgress(false);
            generalStore.showSuccessSnackbar(t("menu:menuEditor.positionCopied"));
            await bookingStore.fetchMenuById(originalMenuId);
            //history.push(`/menus/${menuStore.currentMenu.id}/${newCategory}/${res.menuItemId}`);
            bookingStore.resetNewCategory();
            closeForm();
        }
    }

    const chooseToCopy = (fn: (value: any) => void) => {
        return (e: React.ChangeEvent<HTMLInputElement>) => {
            e.persist();
            e.stopPropagation();
            e.preventDefault();
            fn(e.target.value);
        };
    };

    return (
        <Dialog
            open={open}
            onClose={closeForm}
            aria-labelledby="form-dialog-title"
            fullWidth={true}
            maxWidth={"md"}
            fullScreen={!isSm}
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
            }}
        >
            <DialogTitle id="form-dialog-title">
                {t("menu:menuEditor.copyMenuItem")}
            </DialogTitle>
            <DialogContent>
                <FormControl component="fieldset">
                    <RadioGroup>
                        <FormControlLabel
                            onClick={() => {
                                setCopyToThisMenu(true)
                            }}
                            control={
                                <Radio
                                    checked={copyToThisMenu}

                                    value={copyToThisMenu}
                                />
                            }
                            label={t("menu:menuEditor.copyToThisMenu")}
                        />
                        <Space size={2}/>
                        <FormControlLabel
                            onClick={() => {
                                setCopyToThisMenu(false)
                            }}
                            control={
                                <Radio
                                    checked={!copyToThisMenu}

                                    value={!copyToThisMenu}
                                />
                            }
                            label={t("menu:menuEditor.copyToMenu")}
                        />
                    </RadioGroup>
                </FormControl>
                {!copyToThisMenu &&
                    <div className={style.copyToMenu}>
                        <FormControl fullWidth
                                     variant="outlined"
                                     className={style.chooseMenu}>
                            <InputLabel htmlFor="menu">
                                {t("menu:menuEditor.chooseMenu")}
                            </InputLabel>
                            <Select
                                value={menuId}
                                onChange={chooseToCopy(setMenuId)}
                                input={<OutlinedInput
                                    labelWidth={80}
                                />}
                            >
                                {
                                    generalMenuStore.bookingList.map(menu => {
                                        return (
                                            <MenuItem value={menu.id} key={menu.id}>
                                                {localize(menu.data.name)}
                                            </MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </FormControl>
                        <FormControl fullWidth
                                     variant="outlined"
                                     className={style.chooseMenu}>
                            <InputLabel htmlFor="menu">
                                {t("menu:menuEditor.chooseCategory")}
                            </InputLabel>
                            <Select
                                value={categoryId}
                                onChange={chooseToCopy(setCategoryId)}
                                input={<OutlinedInput
                                    labelWidth={80}
                                />}
                                disabled={!menuId}
                            >
                                {
                                    bookingStore.categoriesList.map(category => {
                                        return (
                                            <MenuItem value={category.id} key={category.id}>
                                                {localize(category.data.name)}
                                            </MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </FormControl>
                    </div>
                }

            </DialogContent>

            <DialogActions style={{paddingRight: 20, paddingBottom: 10}}>
                {
                    isCopyingItemInProgress &&
                    <Button
                        color="primary"
                        disabled
                    >
                        <CircularProgress
                            size={25}
                            color="secondary"
                        />
                    </Button>
                }
                <Button
                    color="default"
                    mr={3}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        closeForm()
                    }}
                >
                    {t("general:close")}
                </Button>
                {
                    !isCopyingItemInProgress &&
                    <Button
                        color="primary"
                        variant={'contained'}
                        mr={3}
                        onClick={copy}
                    >
                        {t("general:copy")}
                    </Button>
                }

            </DialogActions>
        </Dialog>
    );
};

export default observer(CopyBookingItemForm);
